"use strict";
import a from "./index.es348.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
//# sourceMappingURL=index.es414.js.map
